import { React } from 'react';
import Layout from './components/Layout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Contact } from './components/pages/Contact';
import { Home } from './components/pages/Home';
import { Product } from './components/pages/Product';
import { CartProvider } from './context/CartContext';
import { Cart } from './components/pages/Cart';
import { CheckoutSuccess } from './components/pages/CheckoutSuccess';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkoutsuccess" element={<CheckoutSuccess />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
